/*
 * IS THIS PAGE A SHARED SNIPPET? (the recipient's viewer at /s/<token>). Read from the address, so it is true from the very first request: the viewer must be set up BEFORE the dashboard asks for anything.
 * SHARING is the build switch: the demo today (the snippets are kept in the browser), staging and production once the server side exists (REACT_APP_PLAYBACK_SHARE, 0 until then).
 */
export const SHARING: boolean = process.env.REACT_APP_DEMO === "1" || process.env.REACT_APP_PLAYBACK_SHARE === "1";

export const shareTokenFromPath = (pathname: string): string | null => {
  const match = /^\/s\/([A-Za-z0-9_-]{8,64})\/?$/.exec(pathname || "");

  return match ? match[1] : null;
};

export const isShareView = (): boolean => SHARING && typeof window !== "undefined" && shareTokenFromPath(window.location.pathname) !== null;
